import api from './axiosConfig';

export interface HVAScorecardQuestion {
  id?: number;
  scorecardid?: number;
  questionorder: number;
  questiontitle: string;
  questiontext: string;
  questionweight: number;
  answerformat: string;
}

export interface HVAScorecard {
  id: number;
  name: string;
  systemdefault: boolean;
  production: boolean;
  active: boolean;
  questions: HVAScorecardQuestion[];
}

export interface NewHVAScorecard {
  name: string;
  systemdefault: boolean;
  production: boolean;
  active: boolean;
}

export interface NewHVAScorecardQuestion {
  questionorder: number;
  questiontitle: string;
  questiontext: string;
  questionweight: number;
  answerformat: string;
}

interface QuestionReview {
  questionId: number;
  score: number | null;
  comment: string;
}

interface ScorecardReview {
  callId: string;
  scorecardId: number;
  questions: QuestionReview[];
}

export const fetchHVAScorecards = async (): Promise<HVAScorecard[]> => {
  try {
    const response = await api.get('/scorecardmanagement/hvascorecards');
    return response.data;
  } catch (error) {
    console.error('Error fetching scorecards:', error);
    throw error;
  }
};

export const createHVAScorecard = async (
  data: NewHVAScorecard
): Promise<void> => {
  try {
    await api.post('/scorecardmanagement/hvascorecards', data);
  } catch (error) {
    console.error('Error creating scorecard:', error);
    throw error;
  }
};

export const updateHVAScorecard = async (
  id: number,
  data: Partial<HVAScorecard>
): Promise<void> => {
  try {
    await api.put(`/scorecardmanagement/hvascorecards/${id}`, data);
  } catch (error) {
    console.error(`Error updating scorecard with id ${id}:`, error);
    throw error;
  }
};

export const deleteHVAScorecard = async (id: number): Promise<void> => {
  try {
    await api.delete(`/scorecardmanagement/hvascorecards/${id}`);
  } catch (error) {
    console.error(`Error deleting scorecard with id ${id}:`, error);
    throw error;
  }
};

export const fetchHVAScorecardQuestions = async (
  scorecardId: number
): Promise<HVAScorecardQuestion[]> => {
  try {
    const response = await api.get(
      `/scorecardmanagement/hvascorecards/${scorecardId}/questions`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching questions for scorecard ${scorecardId}:`,
      error
    );
    throw error;
  }
};

export const createHVAScorecardQuestion = async (
  scorecardId: number,
  data: NewHVAScorecardQuestion
): Promise<void> => {
  try {
    await api.post(
      `/scorecardmanagement/hvascorecards/${scorecardId}/questions`,
      data
    );
  } catch (error) {
    console.error(
      `Error creating question for scorecard ${scorecardId}:`,
      error
    );
    throw error;
  }
};

export const updateHVAScorecardQuestion = async (
  id: number,
  data: Partial<HVAScorecardQuestion>
): Promise<void> => {
  try {
    await api.put(`/scorecardmanagement/hvascorequestions/${id}`, data);
  } catch (error) {
    console.error(`Error updating scorecard question with id ${id}:`, error);
    throw error;
  }
};

export const deleteHVAScorecardQuestion = async (id: number): Promise<void> => {
  try {
    await api.delete(`/scorecardmanagement/hvascorequestions/${id}`);
  } catch (error) {
    console.error(`Error deleting scorecard question with id ${id}:`, error);
    throw error;
  }
};

export const submitScorecardReview = async (
  review: ScorecardReview
): Promise<void> => {
  try {
    await api.post('/scorecardmanagement/callscorecardreview', review);

    console.log('Scorecard review submitted successfully');
  } catch (error) {
    console.error('Error submitting scorecard review:', error);
    throw error;
  }
};
